import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CalendarsManagementView } from "src/components/views/spc/masterData/calendars/CalendarsManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/calendars")({
	staticData: { title: i18n.t("calendars"), legacyViewKey: "calendarsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CalendarsManagementView />;
}
